import axios, { AxiosResponse } from "axios";
import {mainStorage} from "@/composables/tools/main-storage.tools";
import router from "@/router/index";

let interval: number | null = null;

interface LoginData {
    username: string;
    password: string;
}

interface AuthResponse {
    access_token: string;
    refresh_token: string;
    expires_in: number;
    refresh_expires_in: number;
}

interface LoginResult {
    status: boolean;
    code: number;
}

export async function LogIn(data: LoginData): Promise<LoginResult> {
    try {
        const result: AxiosResponse<AuthResponse> = await axios.post("/globus/api/Auth/login", data);
        await setRefresh(result.data);
        await setAccess(result.data);
        return {status: true, code: 200};
    } catch(e: unknown) {
        console.log(e);
        if (axios.isAxiosError(e)) {
            return {status: false, code: e.response?.status || 500};
        }
        return {status: false, code: 500};

    }
}

async function setRefresh(data: AuthResponse): Promise<void> {
    mainStorage.setItem("refresh_token", data.refresh_token);
    mainStorage.setItem("refresh_time_end", getTimeEnd(data.refresh_expires_in).toString());
    checkEndRefreshToken();
}


async function setAccess(data: AuthResponse): Promise<void> {
    mainStorage.setItem("access_token", data.access_token);
    mainStorage.setItem("access_time_end", getTimeEnd(data.expires_in).toString());
}

export async function getToken(): Promise<string | false> {
    try {
        return await getRefresh();
    } catch (e) {
        console.log(e);
        return false;
    }
}

export async function getRefresh(): Promise<string | false> {
    try {
        if (mainStorage.getItem("refresh_token")) {
            const result: AxiosResponse<AuthResponse> = await axios.post("/globus/api/Auth/refresh",
                {refresh_token: mainStorage.getItem("refresh_token")});
            await setRefresh(result.data);
            await setAccess(result.data);
            return result.data.access_token;
        } else return false;
    } catch(err) {
        await exit();
        console.log(err);
        return false;
    }
}

function checkEndRefreshToken(): void {
    if(interval) {
        clearInterval(interval);
    }

    const refreshTimeEnd = mainStorage.getItem("refresh_time_end");

    interval = setInterval(async () => {
        if(Date.now() > Number(refreshTimeEnd)) {
            if (interval) {
                clearInterval(interval);
            }

            await exit();
        }
    }, 10000) as unknown as number;
}

function getTimeEnd(sec: number): number {
    const currentTime = Date.now();

    return currentTime + (sec * 1000);
}

export async function exit(): Promise<void> {
    mainStorage.setItem("access_token", "");
    mainStorage.setItem("access_time_end", "1");
    mainStorage.setItem("refresh_time_end", "1");
    mainStorage.setItem("timeEnd", "1");
    mainStorage.setItem("refresh_token", "");
    await router.push("/login");
    window.location.reload();
}
